import type { ReactNode } from "react";

export type Tone = "neutral" | "ok" | "warn" | "danger" | "brand";

interface MetricTileProps {
  label: string;
  value: ReactNode;
  unit?: string;
  hint?: ReactNode;
  tone?: Tone;
  icon?: ReactNode;
  rows?: { label: string; value: ReactNode }[];
}

export function MetricTile({
  label,
  value,
  unit,
  hint,
  tone = "neutral",
  icon,
  rows,
}: MetricTileProps) {
  const cls = ["tile", tone !== "neutral" ? `tile--${tone}` : ""]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={cls}>
      <div className="tile__label">
        {icon}
        {label}
      </div>
      <div className="tile__value-row">
        <span className="tile__value">{value}</span>
        {unit && <span className="tile__unit">{unit}</span>}
      </div>
      {hint && <p className="tile__hint">{hint}</p>}
      {rows && rows.length > 0 && (
        <div className="tile__rows">
          {rows.map((r) => (
            <div key={r.label} className="tile__row">
              <div className="tile__row-label">{r.label}</div>
              <div className="tile__row-value">{r.value}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
